import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=09da5584"
import script from "./sidebarMenu.vue?vue&type=script&lang=js"
export * from "./sidebarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports